// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { RecipientType } from "../../data/messaging/recipient-type";
import { Contact } from "../../data/app-core/contact";
import { MessageDocument } from "./documents/message-document";
import { ItemEnvelope } from "./base/item-envelope";

export class MessageEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Message");
		if (jsonEnvelope) {
			this.RecipientTypesPool = jsonEnvelope.RecipientTypesPool;
			this.ContactsPool = jsonEnvelope.ContactsPool;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public RecipientTypesPool: RecipientType[] = [];
	public ContactsPool: Contact[] = [];
	public override Document: MessageDocument = new MessageDocument();
	public override get ItemId(): number { return this.Document.Item.MessageId; }
	public override get ItemName(): string { return "MessageId: " + this.Document.Item.MessageId.toString(); }
}